import React from "react";
import { useRouteContext } from "@providers/RouteProvider";
import Header from "@components/Header";
import Footer from "@components/Footer";
import Banner from "@components/Banner";
import Breadcrumb from "@components/Breadcrumbs";
import Details from "@components/OfferDetail/Details";
import OtherOffers from "@components/OfferDetail/OtherOffers";
import StayInpired from "@components/Home/StayInspired";
import _ from "lodash";
import { usePageContext } from "@providers/PageProvider";
import helper, { offerDetailPage } from "@utils/helper";

const View = ({ data }: any) => {
  const { router } = useRouteContext();
  const { offer, hotel } = usePageContext();
  const banner = offerDetailPage.formatBanner(offer);
  const footer = helper.renderDetailsFooter(hotel);
  return (
    <div className="offerDetailPage" data-scroll-container>
      <Header />
      <Banner
        title={_.get(banner, "title", "")}
        image={_.get(banner, "image")}
      />
      <Breadcrumb
        data={router.breadcrumbs("offer-detail", {
          ...offer,
          hotel,
          title: _.get(banner, "title", ""),
        })}
      />
      <Details />
      <OtherOffers data={_.get(data, "offers", [])} />
      <StayInpired mode="light" />
      {/* <Tabs defaultActiveKey={"all_offers"} items={TABS} /> */}
      <Footer
        data={{
          name: footer.name,
          address: footer.address,
          email: footer.email,
          phone: footer.phone,
        }}
      />
    </div>
  );
};

export default View;
